export const isDevMode = (): boolean => process.env.NODE_ENV === 'development';

// TODO (S.Panfilov) add unit tests
export const isDevMockApiMode = (): boolean => process.env.VUE_APP_MODE === 'dev-mock-api';

export function getServerPrefix({ hostname, origin }: { readonly hostname: string; origin: string }): string {
  // TODO (S.Panfilov) add unit tests
  if (isDevMockApiMode()) return process.env.VUE_APP_BASE_API_URL as string;
  if (isDevMode()) return '';

  return origin;
}
